// import React from "react";

// export const Textarea = React.memo(({ label, name, type = "text", value = "", placeholder=undefined, onChange, disabled, required, isReport }) => {
     
//     if (isReport) {
//       return (
//           <p>{label}{required && "*"}: {value}</p>
//       );
//     }
  
//     return (
//       <div className="form-group">
//         <label>{label}{required && "*"}</label>
//         <textarea
//           type={type}
//           name={name}
//           placeholder={placeholder || ""} 
//           value={value}
//           onChange={onChange}
//           disabled={disabled}
//           required={required}
//         />
//       </div>
//     );
//   });


import React from "react";
import { FaInfoCircle } from "react-icons/fa";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { useTooltips } from "../../hooks/toolTips"; // adjust as needed


const getTooltip = (tooltips, label, name) => {
  if (!Array.isArray(tooltips)) {
    console.warn("❌ Tooltips is not an array:", tooltips);
    return "";
  }

  const match = tooltips.find(
    (t) =>
      (label && t.Label?.toLowerCase().trim() === label.toLowerCase().trim()) ||
      (name && t.Name?.toLowerCase().trim() === name.toLowerCase().trim())
  );

  if (!match) {
    console.log(`🔍 No tooltip match found for label="${label}" name="${name}"`);
    return "";
  }

  const tooltipText = match.Tooltip?.trim();
  console.log(`🧩 Found tooltip for "${label || name}": "${tooltipText}"`);

  if (!tooltipText || tooltipText.toLowerCase() === "123" || tooltipText.length < 7) {
    console.log("⚠️ Tooltip skipped (too short or invalid):", tooltipText);
    return "";
  }

  return tooltipText;
};

export const Textarea = React.memo(
  ({
    label,
    name,
    type = "text",
    value = "",
    placeholder = undefined,
    onChange,
    disabled,
    required,
    isReport,
    tooltip, // optional manual override
    ...rest
  }) => {
    const tooltips = useTooltips();
    const resolvedTooltip = tooltip || getTooltip(tooltips, label?.replace(/:$/, ""), name);

    if (isReport) {
      return (
        <p>
          {label}
          {required && "*"}: {value}
        </p>
      );
    }

    return (
      <div className="form-group">
        <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          {label}
          {required && "*"}
          {resolvedTooltip && (
            <>
              <span
                data-tooltip-id={`tooltip-${name}`}
                style={{ cursor: "pointer" }}
              >
                <FaInfoCircle size={14} color="#07b1b0" />
              </span>
              <Tooltip
                id={`tooltip-${name}`}
                place="right"
                className="custom-tooltip clickable-tooltip"
                openOnClick={true}
                clickable={true}
                globalCloseEvents={{ clickOutsideAnchor: true }}
              >
                <div className="tooltip-text" dangerouslySetInnerHTML={{ __html: resolvedTooltip.replace(/\n/g, "<br/>") }} />
              </Tooltip>
            </>
          )}
        </label>

        <textarea
          type={type}
          name={name}
          placeholder={placeholder || ""}
          value={value}
          onChange={onChange}
          disabled={disabled}
          required={required}
          {...rest}
        />
      </div>
    );
  }
);


